import axios, { AxiosInstance } from "axios";
import { CreateKlantcontactEndpointClient, ICreateKlantcontactEndpointClient } from "./client.generated.klantcontactService";


export class ClientFactory {
  private readonly baseUrl: string;
  private readonly instance?: AxiosInstance;

  constructor(apiUrl) {
    this.baseUrl = apiUrl;
    this.instance = axios;
  }

  getKlantContactEndpointClient = (): ICreateKlantcontactEndpointClient => {
    return new CreateKlantcontactEndpointClient(this.baseUrl + "/klantcontact", this.instance);
  };
}
